import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';

import './style.css'

export default class LightboxExample extends Component {
    constructor(props) {
        super(props)
        this.state = {
            photoIndex: 0,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            photoIndex: nextProps.photoIndex || 0
        })
    }

    

    render() {
        const {
            photoIndex,
        } = this.state;
        
        let {
                isOpen,
                images,
             } = this.props
        
        

        return (
            <div>
                {isOpen &&
                    <Lightbox
                        mainSrc={images[photoIndex]}
                        nextSrc={images[(photoIndex + 1) % images.length]}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length]}

                        enableZoom={false}

                        onCloseRequest={() => this.props.handleClose()}
                        onMovePrevRequest={() => this.setState({
                            photoIndex: (photoIndex + images.length - 1) % images.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            photoIndex: (photoIndex + 1) % images.length,
                        })}
                    />
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/third-party/ImageLightBox/index.js